'use strict';

var KayleeBase = require('./KayleeBase');
var KayleeCompany = require('./KayleeCompany');
var KayleeIsRole = require('./KayleeIsRole');
var KayleeRoom = require('./KayleeRoom');
var KayleeSite = require('./KayleeSite');
var log = require('../log/Log').channel('KayleeRoles');
var sutl = require('../sutl/Sutl');

var KayleeRoles = {
    getRelevantRoles: getRelevantRoles,
    isRole: KayleeIsRole.isRole,
    setRoleByEmail: setRoleByEmail,
};

var roles = {};

function getRelevantRoles(user, node) {
    if (typeof user === 'undefined' || user === null ||
        typeof node === 'undefined' || node === null) {
        return null;
    }

    if (!roles.hasOwnProperty(user.$id)) {
        user.$onChange(onChangeCb);
        user.$onDestroy(onDestroyCb);
        roles[user.$id] = {};
    }

    if (!roles[user.$id].hasOwnProperty(node.$id)) {
        if (node.$nodeType === 'company') {
            getRolesForCompany(user, node);
        } else if (node.$nodeType === 'site') {
            getRolesForSite(user, node);
        } else if (node.$nodeType === 'room') {
            getRolesForRoom(user, node);
        } else {
            log.error('invalid type for node ' + node);
            return null;
        }
    }
    
    return roles[user.$id][node.$id];
}

function onChangeCb(user) {
    delete roles[user.$id];
}

function onDestroyCb(user) {
    delete roles[user.$id];
}

function getRolesForCompany(user, company) {
    roles[user.$id][company.$id] = [];
    var theseRoles = roles[user.$id][company.$id];

    if (sutl.nodeExists(user, ['roles', 'companies', company.$id])) {
        var cr = user.roles.companies[company.$id];

        if (cr.hasOwnProperty('role')) {
            theseRoles.push({
                company: company,
                role: cr.role,
            });
        }

        for (var siteId in cr.sites) {
            if (!cr.sites.hasOwnProperty(siteId)) continue;
            var sr = cr.sites[siteId];

            if (sr.hasOwnProperty('role')) {
                theseRoles.push({
                    company: company,
                    site: KayleeSite.getSite(siteId),
                    role: sr.role,
                });
            }

            for (var roomId in sr.rooms) {
                if (!sr.rooms.hasOwnProperty(roomId)) continue;
                var rr = sr.rooms[roomId];

                if (rr.hasOwnProperty('role')) {
                    theseRoles.push({
                        company: company,
                        site: KayleeSite.getSite(siteId),
                        room: KayleeRoom.getRoom(roomId),
                        role: rr.role,
                    });
                }
            }
        }
    }
}

function getRolesForSite(user, site) {
    roles[user.$id][site.$id] = [];
    var theseRoles = roles[user.$id][site.$id];

    if (sutl.nodeExists(user, ['roles', 'companies', site.companyId])) {
        var cr = user.roles.companies[site.companyId];

        if (cr.hasOwnProperty('role')) {
            theseRoles.push({
                company: KayleeCompany.getCompany(site.companyId),
                role: cr.role,
            });
        }

        if (sutl.nodeExists(cr, ['sites', site.$id])) {
            var sr = cr.sites[site.$id];

            if (sr.hasOwnProperty('role')) {
                theseRoles.push({
                    company: KayleeCompany.getCompany(site.companyId),
                    site: site,
                    role: sr.role,
                });
            }

            for (var roomId in sr.rooms) {
                if (!sr.rooms.hasOwnProperty(roomId)) continue;
                var rr = sr.rooms[roomId];

                if (rr.hasOwnProperty('role')) {
                    theseRoles.push({
                        company: KayleeCompany.getCompany(site.companyId),
                        site: site,
                        room: KayleeRoom.getRoom(roomId),
                        role: rr.role,
                    });
                }
            }
        }
    }
}

function getRolesForRoom(user, room) {
    roles[user.$id][room.$id] = [];
    var theseRoles = roles[user.$id][room.$id];

    if (sutl.nodeExists(user, ['roles', 'companies', room.companyId])) {
        var cr = user.roles.companies[room.companyId];

        if (cr.hasOwnProperty('role')) {
            theseRoles.push({
                company: KayleeCompany.getCompany(room.companyId),
                role: cr.role,
            });
        }

        if (sutl.nodeExists(cr, ['sites', room.siteId])) {
            var sr = cr.sites[room.siteId];

            if (sr.hasOwnProperty('role')) {
                theseRoles.push({
                    company: KayleeCompany.getCompany(room.companyId),
                    site: KayleeSite.getSite(room.siteId),
                    role: sr.role,
                });
            }

            if (sutl.nodeExists(sr, ['rooms', room.$id, 'role'])) {
                theseRoles.push({
                    company: KayleeCompany.getCompany(room.companyId),
                    site: KayleeSite.getSite(room.siteId),
                    room: room,
                    role: sr.rooms[room.$id].role,
                });
            }
        }
    }
}

function setRoleByEmail(email, node, role) {
    return KayleeBase.request('roleRequest', {
        nodeType: node.$nodeType,
        nodeId: node.$id,
        role: role,
        userEmail: email,
    });
}

module.exports = KayleeRoles;
